<template>
  <v-toolbar flat color="white" density="compact">
    <span class="reg-bold text-primary">{{ $store.getters.translate("cuuriosplanning") }}</span>
    <v-spacer/>
    <base-action-button @action="createCuuriosPlanning">
      <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
      {{ $store.getters.translate("create") }}
    </base-action-button>
  </v-toolbar>
  <v-data-table
      class="elevation-1 mt-5"
      :headers="headers"
      :items="cuurios_planning"
      :show-select="false"
      :items-per-page="100">
    <template #item.name="{ item }">
      <a class="sm-bold" v-if="item.url" :href="item.url" target="_blank">{{ item.name }}</a>
      <span v-else @click.stop="editCuuriosPlanning(item)">{{ item.name }}</span>
    </template>
    <template #item.actions="{ item }">
      <v-menu>
        <template #activator="{ props }">
          <v-btn elevation="0" icon v-bind="props">
            <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="editCuuriosPlanning(item)">
            <template #prepend><PhPencilSimpleLine size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteCuuriosPlanning(item)">
            <template #prepend><PhTrash size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template #bottom/>
  </v-data-table>
  <base-create-dialog modal_name="create_cuurios_planning" ref="create_cuurios_planning" :page="page" @refresh="load"/>
  <base-edit-dialog modal_name="edit_cuurios_planning" ref="edit_cuurios_planning" :page="page" :internal_model="true" @refresh="load"/>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import {PhDotsThreeVertical, PhPencilSimpleLine, PhPlus, PhTrash} from "@phosphor-icons/vue";
import BaseCreateDialog from "./BaseCreateDialog";
import BaseEditDialog from "./BaseEditDialog";

export default {
  components: {BaseEditDialog, BaseCreateDialog, PhTrash, PhPencilSimpleLine, PhDotsThreeVertical, PhPlus, BaseActionButton},
  props: ["project_management_id"],
  data() {
    return {
      page: helpFunctions.pages.cuuriosplanning,
      headers: [],
      cuurios_planning: [],
    };
  },
  created() {
    this.headers = helpFunctions.composeTableHeaders(helpFunctions.headers.cuurios_planning);
    this.load();
  },
  methods: {
    async load() {
      if(this.project_management_id) {
        this.cuurios_planning = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?project_management_id=" + this.project_management_id);
      }
    },
    createCuuriosPlanning() {
      this.$refs.create_cuurios_planning.load();
      this.$refs.create_cuurios_planning.record.project_management_id = this.project_management_id;
    },
    editCuuriosPlanning(item) {
      this.$refs.edit_cuurios_planning.load(item.id);
    },
    deleteCuuriosPlanning(item) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, item.id);
          await this.load();
        }
      });
    },
  },
  watch: {
    project_management_id: {
      handler() {
        this.load();
      },
    },
  },
};
</script>